import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {CICOItemIdsToAssignee} from 'constants/SampleStatusConstants';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import BaseCheckOutFromProcessTableModal, {
  BaseCheckoutFromProcessTableModalProps,
} from 'inventory/check-in-check-out/BaseCheckOutFromProcessTableModal';
import * as CICOActions from 'inventory/check-in-check-out/CICOActions';

export default function CheckOutFromProcessTableModal(
  props: Omit<BaseCheckoutFromProcessTableModalProps, 'statusWarningTrackingParams' | 'onCheckOut'>
): JSX.Element {
  return (
    <BaseCheckOutFromProcessTableModal
      targetTaskIdsAndStorables={props.targetTaskIdsAndStorables}
      onCheckOut={(itemIdsToAssignee: CICOItemIdsToAssignee, comment?: string): void => {
        CICOActions.checkOut(itemIdsToAssignee, {comment});
      }}
      onRequestClose={props.onRequestClose}
      title="Check out"
      actionVerb="checked out"
      statusWarningTrackingParams={{
        actionOrigin: props.analyticsMetadata?.actionOrigin ?? ActionOrigin.UI_UNDETERMINED,
        actionAttempted: 'check_out',
        eventGroupId: props.analyticsMetadata?.eventGroupId ?? Analytics.makeAnalyticsEventId(),
      }}
      analyticsMetadata={{...props.analyticsMetadata, modalType: 'check_out'}}
      shouldAlwaysShowSampleStatusTable={props.shouldAlwaysShowSampleStatusTable}
    />
  );
}
